import { ReactNode } from 'react';

import { cn } from '@/lib/utils/tailwind';

type SheetFooterProps = {
  children: ReactNode;
  className?: string;
};
const SheetFooter = ({ children, className, ...props }: SheetFooterProps) => (
  <div className={cn('p-4 border-t border-border', className)} {...props}>
    {children}
  </div>
);

export { SheetFooter };
